<template>
  <b-modal class="customer-show-payment" ref="modal" :title="dialog_title" hide-footer>
    <div class="row form-group">
      <!-- DATE -->

      <div class="col" :class="{ 'col-sm-12': !can_invoice }">
        <input type="datetime-local" v-model="created_at" class="form-control" id="customer-show-payment-created-at"
          required />
        <label for="customer-show-payment-created-at" class="wabident-info">Fecha</label>
      </div>

      <!-- INVOICE -->
      <div v-if="can_invoice && (is_editing || !is_invoiced)" class="col-sm-7">
        <select v-model="invoice_id" id="customer-show-payment-invoice" class="form-control custom-select">
          <option :value="null">Sin factura</option>
          <option v-for="(invoice, index) in filtered_invoices" :key="index" :value="invoice.id">
            {{ invoice.code }}
            <span v-if="invoice.total_amount">
              - {{ invoice.total_amount }}</span>
            <span v-if="invoice.notes"> - {{ invoice.notes }}</span>
          </option>
        </select>
        <label for="customer-show-payment-invoice" class="wabident-info">
          Factura asociada
        </label>
      </div>

      <!-- QUANTITY -->
      <div class="col-sm-3">
        <input id="customer-show-payment-amount" type="number" v-model.number="amount" step="0.01" class="form-control"
          :readonly="restrict_editing" />
        <label for="customer-show-payment-amount" class="wabident-info">Cantidad</label>
      </div>

      <!-- VAT -->
      <div v-if="selected_treatments.length <= 0" class="col-sm-4">
        <select name="vat" id="show_vat" v-model="vat" class="custom-select" required :disabled="restrict_editing">
          <option :value="null">Seleccionar ...</option>
          <option v-for="tax in clinic.taxes" :value="parseInt(tax.value)" :key="tax.id">
            {{ tax.name }}
          </option>
        </select>
        <label class="wabident-info" for="show_vat">Impuestos Aplicados</label>
      </div>

      <!-- TYPE -->
      <div class="col">
        <select v-model="type" id="customer-show-payment-type" class="form-control custom-select" required
          :disabled="restrict_editing">
          <option :value="null">Seleccionar</option>
          <option value="cash">Efectivo</option>
          <option value="credit_card">Tarjeta</option>
          <option value="transfer">Transferencia</option>
          <option value="mobile">Bizum/Móvil</option>
          <option value="direct_debit">Financiación</option>
          <option v-if="is_core" value="expense_interests">
            Intereses Fin.
          </option>
          <option v-if="is_core" value="tpv">TPV</option>
          <option v-if="enable_sepa_transfers" value="sepa_transfer">Recibo (SEPA)</option>
          <option value="other">Otros</option>
        </select>
        <label for="customer-show-payment-type" class="wabident-info">Forma de pago</label>
      </div>
    </div>

    <div v-if="show_financing_row" class="row form-group">
      <div class="col-12">
        <strong>DATOS DE FINANCIACIÓN</strong>
      </div>
      <div class="col-sm-6">
        <select v-model="financing_type" id="customer-financing-type" class="form-control custom-select">
          <option :value="null">Sin comisión</option>
          <option value="abs">Valor fijo</option>
          <option value="percent">Porcentaje</option>
        </select>
        <label for="customer-financing-type" class="wabident-info">Tipo de comisión</label>
      </div>

      <div v-if="financing_type !== null" class="col-sm-6">
        <input v-model.number="financing_amount" id="customer-financing-amount" type="number" class="form-control"
          step="0.01" />
        <label for="customer-financing-amount" class="wabident-info">Valor Comisión <span
            v-if="financing_type == 'percent'">(%)</span>
          <span v-else>(€)</span>
        </label>
      </div>
    </div>

    <div class="row">
      <div class="col-12 mb-2">
        <strong>CONCEPTO / TRATAMIENTOS</strong>
      </div>
    </div>

    <!-- TREATMENTS SELECTOR -->
    <div v-if="selected_treatments.length <= 0 && !show_financing_row" class="row form-group">

      <div class="col-md-12 mb-2">
        <div class="form-check form-check-inline">
          <input v-model="show_all_treatments" class="form-check-input" type="checkbox" id="treatment_show_all"
            :value="true" />
          <label class="form-check-label" for="treatment_show_all">Mostrar todos los tratamientos <small>(Pagados y
              Realizados inclusive)</small></label>
        </div>
      </div>

      <div class="col-md-12">
        <select v-model="selected_treatment" @change="selectedTreatment($event.target.value)"
          id="customer-pay-treatment" class="form-control custom-select" :disabled="restrict_editing">
          <option :value="null">Seleccionar tratamiento</option>
          <option v-for="(treatment, index) in available_treatments" :key="index" :value="treatment.id">
            {{ treatment.full_name }}
            <span v-if="treatment.quoted_price">
              - {{ getQuotedPrice(treatment) }}
            </span>
            <span v-if="treatment.is_paid">
              - Pagado
            </span>
            <span v-else>
              - Sin pagar
            </span>

            <span v-if="treatment.status == 'done'">
              - Realizado
            </span>
            <span v-else>
              - Pendiente
            </span>
          </option>
        </select>
        <label for="customer-pay-treatment" class="wabident-info">Tratamiento a <span
            v-if="is_assignment">pagar</span><span>adelantar</span></label>
      </div>
    </div>

    <!-- TREATMENTS LIST -->
    <div v-show="selected_treatments.length" class="form-group row no-gutters">
      <div class="col-sm-12">
        <a role="button" @click="removeTreatment(treatment.id)"
          class="btn wabident-badge wabident-badge__clear wabident-badge__ellipsis"
          v-for="treatment in selected_treatments" style="margin: 4px" :key="treatment.id">{{ treatment.full_name }}
          <span v-if="treatment.quoted_price">
            - {{ getQuotedPrice(treatment) }}
          </span>
        </a>
      </div>
    </div>

    <!-- CHECKBOX STRIP -->
    <div class="form-group row" v-if="!is_editing && selected_treatments.length">
      <legend>Tras guardar:</legend>
      <div class="col-sm-12">
        <div class="form-check form-check-inline">
          <input v-model="is_paid" class="form-check-input" type="checkbox" id="treatment_is_paid" :value="true" />
          <label class="form-check-label" for="treatment_is_paid">Marcar como Pagados</label>
        </div>
        <div v-if="is_assignment" class="form-check form-check-inline">
          <input v-model="is_done" class="form-check-input" type="checkbox" id="treatment_is_done" :value="true" />
          <label class="form-check-label" for="treatment_is_done">Marcar como Realizados</label>
        </div>
        <div v-if="can_invoice && !invoice_id" class="form-check form-check-inline">
          <input v-model="is_invoiced" class="form-check-input" type="checkbox" id="treatment_is_invoiced"
            :value="true" />
          <label class="form-check-label" for="treatment_is_invoiced">
            Generar factura
            <span v-if="!is_assignment">&nbsp;anticipo</span>
          </label>
        </div>
      </div>
    </div>

    <!-- CONCEPT -->
    <div class="row form-group">
      <div class="col-sm-12">
        <input type="text" v-model="notes" class="form-control" id="customer-show-payment-notes"
          :readonly="restrict_editing" />
        <label for="customer-show-payment-notes" class="wabident-info">Concepto</label>
      </div>
    </div>

    <!-- BUTTON STRIP -->
    <div class="row form-group">
      <div class="col buttons-column text-center">
        <button v-if="is_editing" :disabled="is_loading" @click="deletePayment"
          class="btn btn-wabident-delete float-left" style="width: 53.6px; height: 53.6px"></button>

        <button @click="submit" :disabled="is_loading" type="button" class="btn btn-primary btn-wabident">
          <span v-if="is_editing">Modificar</span>
          <span v-else>Crear </span>
          <i v-if="is_loading" class="fa fa-spin fa-circle-notch float-right"></i>
        </button>

        <button @click="returnPayment" v-if="is_editing" :disabled="is_loading" type="button"
          class="btn btn-primary btn-wabident float-right">
          Devolver&nbsp;<i class="fas fa-undo"></i>
        </button>
      </div>
    </div>
  </b-modal>
</template>

<script>
export default {
  props: {
    customer: { required: true },
  },
  data() {
    return {
      payment_id: 0,
      customer_id: 0,
      is_loading: false,
      invoice_id: null,
      created_at: new Date().toISODateTime(),
      amount: 0,
      type: "cash",
      notes: "",
      vat: null,
      is_paid: false,
      is_done: false,
      is_invoiced: false,
      unpaid_treatments: [],
      selected_treatments: [],
      selected_treatment: null,
      available_invoices: null,
      accounting_entry: null,
      financing_type: null,
      financing_amount: null,
      show_all_treatments: false,
    };
  },
  watch: {
    show_all_treatments(val) {
      this.updateTreatments();
    }
  },
  computed: {
    enable_sepa_transfers() {
      return this.clinic && this.clinic.config.payments_enable_sepa_transfers;
    },
    can_invoice() {
      if (!this.clinic) return false;
      return !this.clinic.config.disable_invoices;
    },
    is_editing() {
      return this.payment_id > 0;
    },
    default_is_invoiced() {
      if (!this.clinic) return false;
      return this.clinic.config["payments_auto_invoice"] || false;
    },
    is_assignment() {
      return this.accounting_entry != "deposit";
    },
    is_dental() {
      if (!this.clinic) return true;
      return this.clinic.type == "dental";
    },
    is_aesthetic() {
      return !this.is_dental;
    },
    restrict_editing() {
      false;
    },
    available_treatments() {
      let selected = this.selected_treatments.map((x) => {
        return x.id;
      });
      return this.unpaid_treatments.filter((x) => {
        return !selected.includes(x.id);
      });
    },
    dialog_title() {
      if (!this.enable_payments_v2) {
        return this.is_editing ? "Editar Cobro" : "Añadir Cobro";
      }

      if (this.is_assignment) {
        return this.is_editing ? "Editar Asignación" : "Añadir Asignación";
      } else {
        return this.is_editing ? "Editar Aportación" : "Añadir Aportación";
      }
    },
    filtered_invoices() {
      if (!this.available_invoices) return [];

      // Filter invoices. Non deposit invoices cannot be assigned to downpayments
      return this.available_invoices.filter((invoice) => {
        if (this.accounting_entry == "deposit") {
          return invoice.is_downpayment;
        }
        return !invoice.is_downpayment;
      });
    },
    enable_payments_v2() {
      return this.clinic.config.enable_payments_v2 || false;
    },
    show_financing_row() {
      return (
        !this.is_assignment && !this.is_editing && this.type == "direct_debit"
      );
    },
    ...mapGetters(["msgwindow", "errorwindow", "clinic", "is_core"]),
  },
  methods: {
    getQuotedPrice(treatment) {
      if (!treatment.quoted_price) {
        return "";
      }
      return window.WabiDent.fmtMoney(treatment.quoted_price);
    },
    showNewDeposit() {
      this.showNew("deposit");
    },
    showNewAssignment() {
      this.showNew("assignment");
    },
    showNew(accounting_entry = null, options = {}) {
      this.show_all_treatments = false;
      this.customer_id = this.customer ? this.customer.id : 0;
      this.payment_id = 0;
      this.amount = options.amount || 0;

      this.type = accounting_entry == "assignment" ? "other" : null;
      this.type = options.type || this.type;

      this.notes = options.notes || "";
      this.invoice_id = null;
      this.$refs.modal.show();
      this.created_at = options.created_at
        ? moment(options.created_at).toDate().toISODateTime()
        : new Date().toISODateTime();
      this.vat = accounting_entry == "deposit" ? 0 : null;
      this.is_paid = false;
      this.is_done = false;
      this.is_invoiced = this.default_is_invoiced;
      this.accounting_entry = accounting_entry;
      this.selected_treatments = [];
      this.financing_amount = null;
      this.financing_type = null;
      this.updateTreatments();
      this.updateInvoices();
    },
    showNewTreatment(treatment, price, invoices = null) {
      this.customer_id = this.customer ? this.customer.id : 0;
      this.payment_id = 0;
      this.amount = price;
      this.type = null;
      this.accounting_entry = "assignment";
      this.financing_amount = null;
      this.financing_type = null;

      if (invoices && invoices.length == 1) {
        this.invoice_id = invoices[0].id;
      } else {
        this.invoice_id = null;
      }

      this.notes = "Pago tratamiento: " + treatment.full_name;

      if (treatment.product.vat === null) {
        this.vat = null;
      } else {
        this.vat = Number.parseFloat(treatment.product.vat);
      }

      this.is_paid = true;
      this.is_done = true;
      this.is_invoiced = this.default_is_invoiced;
      this.created_at = new Date().toISODateTime();
      this.notes = "Pago de tratamientos: " + treatment.full_name;

      if (treatment.teeth && treatment.teeth.length > 0) {
        this.notes += " (" + treatment.teeth.join(",") + ")";
      }

      treatment.quoted_price = price;
      this.selected_treatments = [treatment];
      this.$refs.modal.show();
      this.updateTreatments();
      this.updateInvoices();
    },
    showNewTreatments(treatments, prices, invoices = null) {
      let price = prices.reduce((acc, x) => {
        return acc + x;
      }, 0);

      treatments.forEach((t, index) => {
        t.quoted_price = prices[index];
      });

      this.payment_id = 0;
      this.customer_id = this.customer ? this.customer.id : 0;
      this.amount = price;
      this.type = null;
      this.accounting_entry = null;

      if (invoices && invoices.length == 1) {
        this.invoice_id = invoices[0].id;
      } else {
        this.invoice_id = null;
      }

      let names = treatments.map((t) => {
        let r = t.product.name;
        if (t.teeth && t.teeth.length > 0) {
          this.notes += " (" + t.teeth.join(",") + ")";
        }
        return r;
      });

      this.notes = "Pago tratamientos: " + names.join(", ");
      this.vat = null;

      this.is_paid = true;
      this.is_done = true;
      this.is_invoiced = this.default_is_invoiced;

      this.created_at = new Date().toISODateTime();
      this.selected_treatments = treatments;
      this.financing_amount = null;
      this.financing_type = null;

      this.$refs.modal.show();
      this.updateTreatments();
      this.updateInvoices();
    },
    showEdit(payment) {
      this.show_all_treatments = false;
      this.payment_id = payment.id;
      this.customer_id = this.customer ? this.customer.id : payment.customer_id;
      this.invoice_id = payment.invoice_id;
      this.amount = payment.amount;
      this.notes = payment.notes;
      this.financing_amount = null;
      this.financing_type = null;

      if (payment.vat === null) {
        this.vat = null;
      } else {
        this.vat = parseInt(parseFloat(payment.vat));
      }

      this.created_at = moment(payment.created_at).format("YYYY-MM-DDTHH:mm");
      this.type = payment.type;

      let is_paid = true;
      let is_done = true;

      payment.treatments.forEach((t) => {
        is_paid = is_paid && t.paid_at != null;
        is_done = is_done && t.done_at != null;
      });

      this.is_paid = is_paid;
      this.is_done = is_done;
      this.is_invoiced = false;
      this.accounting_entry = payment.accounting_entry;

      this.$refs.modal.show();
      this.selected_treatments = payment.treatments;
      this.updateTreatments();
      this.updateInvoices();
    },
    updateTreatments() {
      let params = {
        treatments: this.selected_treatments.map((x) => {
          return x.id;
        }),
        all: this.show_all_treatments,
      };

      axios
        .get(`/customer/${this.customer_id}/unpaid`, { params: params })
        .then((response) => {
          this.unpaid_treatments = response.data;
        })
        .catch((err) => {
          this.msgwindow.error("Error obteniendo tratamientos sin pagar");
        });
    },
    updateInvoices() {
      axios
        .get(`/customer/${this.customer_id}/invoices_payment`)
        .then((response) => {
          this.available_invoices = response.data;
          this.$forceUpdate();
        })
        .catch((err) => {
          this.msgwindow.error("Error obteniendo facturas");
        });
    },
    selectedTreatment(treatment_id) {
      if (treatment_id) {
        let id = Number(treatment_id);
        let to_add = this.unpaid_treatments.filter((x) => {
          return x.id == id;
        });
        this.selected_treatments = this.selected_treatments.concat(to_add);
        this.selected_treatment = null;
      }
    },
    removeTreatment(treatment_id) {
      this.selected_treatments = this.selected_treatments.filter((x) => {
        return x.id != treatment_id;
      });
    },
    submit() {
      if (!this.validatePayment()) return;

      if (!this.is_editing) {
        let message = "¿Confirmar creación?";
        this.errorwindow.show(
          "Confirmación",
          message,
          "Crear",
          "Cancelar",
          () => {
            this.addPayment();
          }
        );
      } else {
        this.updatePayment();
      }
    },
    validatePayment() {
      let errors = [];

      if (!this.type) {
        errors.push(
          "<li>Debes seleccionar un Tipo: Efectivo, Tarjeta, etc ..."
        );
      }

      if (!this.amount) {
        errors.push("<li>Debes indicar una Cantidad mínima");
      }

      if (!this.notes && this.selected_treatments.length == 0) {
        if (this.is_assignment) {
          errors.push(
            "<li>Debes indicar el concepto o al menos elegir un tratamiento"
          );
        } else {
          errors.push("<li>Debes indicar el concepto");
        }
      }

      if (this.type == "cash" && this.amount > 1000) {
        errors.push("<li>No puedes ingresar Efectivo superior a 1000€");
      }

      if (
        this.clinic.type != "dental" &&
        this.vat == null &&
        this.selected_treatments.length == 0
      ) {
        errors.push(
          "<li>Debes elegir al menos un tratamiento o un tipo de IVA a aplicar"
        );
      }

      if (errors.length) {
        let message = "<ul>" + errors.join() + "</ul>";
        this.errorwindow.show("Error", "No se puede crear el cobro:" + message);
        return false;
      }

      return true;
    },
    returnPayment() {
      this.errorwindow.show(
        "Confirmación",
        "¿Quieres crear una devolución?",
        "Aceptar",
        "Cancelar",
        () => {
          this.doReturnPayment();
        }
      );
    },
    deletePayment() {
      this.errorwindow.show(
        "Confirmación",
        "¿Quieres borrar el pago? Esta operación no es reversible",
        "Aceptar",
        "Cancelar",
        () => {
          this.doDeletePayment();
        }
      );
    },
    doDeletePayment() {
      if (!this.is_loading) {
        this.is_loading = true;
        axios
          .post(`/customer/${this.customer.id}/payment/${this.payment_id}`, {
            _method: "delete",
          })
          .then((response) => {
            this.$emit("submit");
            this.msgwindow.success("Pago borrado");
            this.$refs.modal.hide();
          })
          .catch((err) => {
            this.msgwindow.error("Error borrando pago !");
            this.$refs.modal.hide();
          })
          .then(() => {
            this.is_loading = false;
          });
      }
    },
    doReturnPayment() {
      if (!this.is_loading) {
        this.is_loading = true;
        axios
          .post(
            `/customer/${this.customer.id}/payment/${this.payment_id}/return`
          )
          .then((response) => {
            this.$emit("submit");
            this.msgwindow.success("Devolución creada");
            this.$refs.modal.hide();
          })
          .catch((err) => {
            this.msgwindow.error("Error en la devolución !");
            this.$refs.modal.hide();
          })
          .then(() => {
            this.is_loading = false;
          });
      }
    },
    updatePayment() {
      if (!this.is_loading) {
        this.is_loading = true;

        var params = {
          amount: this.amount,
          notes: this.notes,
          type: this.type,
          clinic_id: this.clinic ? this.clinic.id : null,
          invoice_id: this.invoice_id,
          created_at: this.created_at,
          treatments: this.selected_treatments.map((x) => {
            return x.id;
          }),
          is_paid: this.is_paid,
          is_done: this.is_done,
          is_invoiced: this.is_invoiced,
          vat: this.vat,
          accounting_entry: this.accounting_entry,
        };

        axios
          .post(
            `/customer/${this.customer.id}/payment/${this.payment_id}`,
            params
          )
          .then((response) => {
            this.$emit("submit");
            this.msgwindow.success("Modificado con éxito");
            this.$refs.modal.hide();
          })
          .catch((err) => {
            this.msgwindow.error("Error modificando !");
            this.$refs.modal.hide();
          })
          .then(() => {
            this.is_loading = false;
          });
      }
    },
    addPayment() {
      if (!this.is_loading) {
        this.is_loading = true;

        var params = {
          amount: this.amount,
          notes: this.notes,
          type: this.type,
          clinic_id: this.clinic ? this.clinic.id : null,
          invoice_id: this.invoice_id,
          created_at: this.created_at,
          treatments: this.selected_treatments.map((x) => {
            return x.id;
          }),
          is_paid: this.is_paid,
          is_done: this.is_done,
          is_invoiced: this.is_invoiced,
          vat: this.vat,
          accounting_entry: this.accounting_entry,
          financing_type: this.financing_type,
          financing_amount: this.financing_amount,
        };

        axios
          .post(`/customer/${this.customer.id}/payment`, params)
          .then((response) => {
            this.$emit("submit");
            this.msgwindow.success("Añadido con éxito");
            this.$refs.modal.hide();
          })
          .catch((err) => {
            this.msgwindow.error("Error añadiendo!");
            this.$refs.modal.hide();
          })
          .then(() => {
            this.is_loading = false;
          });
      }
    },
  },
  mounted() { },
};
</script>
